'use strict';

var cov_1k87b9rbsn = function () {
  var path = 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\Units\\UnitsCtrl.js',
      hash = 'c8e69a3a0e7023f206b893b0f58f9c6c4edcb2e3',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\app\\Units\\UnitsCtrl.js',
    statementMap: {
      '0': {
        start: {
          line: 2,
          column: 1
        },
        end: {
          line: 134,
          column: 4
        }
      },
      '1': {
        start: {
          line: 3,
          column: 3
        },
        end: {
          line: 3,
          column: 38
        }
      },
      '2': {
        start: {
          line: 4,
          column: 3
        },
        end: {
          line: 6,
          column: 4
        }
      },
      '3': {
        start: {
          line: 5,
          column: 5
        },
        end: {
          line: 5,
          column: 12
        }
      },
      '4': {
        start: {
          line: 7,
          column: 3
        },
        end: {
          line: 7,
          column: 22
        }
      },
      '5': {
        start: {
          line: 8,
          column: 3
        },
        end: {
          line: 8,
          column: 23
        }
      },
      '6': {
        start: {
          line: 9,
          column: 3
        },
        end: {
          line: 9,
          column: 28
        }
      },
      '7': {
        start: {
          line: 10,
          column: 3
        },
        end: {
          line: 10,
          column: 25
        }
      },
      '8': {
        start: {
          line: 11,
          column: 3
        },
        end: {
          line: 11,
          column: 25
        }
      },
      '9': {
        start: {
          line: 12,
          column: 3
        },
        end: {
          line: 12,
          column: 27
        }
      },
      '10': {
        start: {
          line: 13,
          column: 3
        },
        end: {
          line: 13,
          column: 27
        }
      },
      '11': {
        start: {
          line: 14,
          column: 19
        },
        end: {
          line: 14,
          column: 49
        }
      },
      '12': {
        start: {
          line: 15,
          column: 3
        },
        end: {
          line: 19,
          column: 5
        }
      },
      '13': {
        start: {
          line: 21,
          column: 3
        },
        end: {
          line: 27,
          column: 5
        }
      },
      '14': {
        start: {
          line: 22,
          column: 5
        },
        end: {
          line: 22,
          column: 29
        }
      },
      '15': {
        start: {
          line: 23,
          column: 5
        },
        end: {
          line: 26,
          column: 8
        }
      },
      '16': {
        start: {
          line: 24,
          column: 7
        },
        end: {
          line: 24,
          column: 31
        }
      },
      '17': {
        start: {
          line: 25,
          column: 7
        },
        end: {
          line: 25,
          column: 32
        }
      },
      '18': {
        start: {
          line: 28,
          column: 3
        },
        end: {
          line: 28,
          column: 19
        }
      },
      '19': {
        start: {
          line: 30,
          column: 3
        },
        end: {
          line: 38,
          column: 5
        }
      },
      '20': {
        start: {
          line: 31,
          column: 5
        },
        end: {
          line: 37,
          column: 8
        }
      },
      '21': {
        start: {
          line: 40,
          column: 3
        },
        end: {
          line: 52,
          column: 5
        }
      },
      '22': {
        start: {
          line: 41,
          column: 26
        },
        end: {
          line: 41,
          column: 44
        }
      },
      '23': {
        start: {
          line: 42,
          column: 5
        },
        end: {
          line: 42,
          column: 102
        }
      },
      '24': {
        start: {
          line: 43,
          column: 5
        },
        end: {
          line: 43,
          column: 76
        }
      },
      '25': {
        start: {
          line: 44,
          column: 5
        },
        end: {
          line: 44,
          column: 40
        }
      },
      '26': {
        start: {
          line: 45,
          column: 5
        },
        end: {
          line: 51,
          column: 8
        }
      },
      '27': {
        start: {
          line: 54,
          column: 3
        },
        end: {
          line: 58,
          column: 5
        }
      },
      '28': {
        start: {
          line: 55,
          column: 5
        },
        end: {
          line: 55,
          column: 24
        }
      },
      '29': {
        start: {
          line: 56,
          column: 5
        },
        end: {
          line: 56,
          column: 25
        }
      },
      '30': {
        start: {
          line: 57,
          column: 5
        },
        end: {
          line: 57,
          column: 30
        }
      },
      '31': {
        start: {
          line: 60,
          column: 3
        },
        end: {
          line: 87,
          column: 5
        }
      },
      '32': {
        start: {
          line: 61,
          column: 5
        },
        end: {
          line: 61,
          column: 29
        }
      },
      '33': {
        start: {
          line: 62,
          column: 5
        },
        end: {
          line: 62,
          column: 29
        }
      },
      '34': {
        start: {
          line: 63,
          column: 5
        },
        end: {
          line: 85,
          column: 6
        }
      },
      '35': {
        start: {
          line: 65,
          column: 9
        },
        end: {
          line: 65,
          column: 33
        }
      },
      '36': {
        start: {
          line: 66,
          column: 9
        },
        end: {
          line: 66,
          column: 33
        }
      },
      '37': {
        start: {
          line: 67,
          column: 9
        },
        end: {
          line: 67,
          column: 15
        }
      },
      '38': {
        start: {
          line: 69,
          column: 9
        },
        end: {
          line: 69,
          column: 33
        }
      },
      '39': {
        start: {
          line: 70,
          column: 9
        },
        end: {
          line: 70,
          column: 33
        }
      },
      '40': {
        start: {
          line: 71,
          column: 9
        },
        end: {
          line: 71,
          column: 15
        }
      },
      '41': {
        start: {
          line: 73,
          column: 9
        },
        end: {
          line: 73,
          column: 33
        }
      },
      '42': {
        start: {
          line: 74,
          column: 9
        },
        end: {
          line: 74,
          column: 34
        }
      },
      '43': {
        start: {
          line: 75,
          column: 9
        },
        end: {
          line: 75,
          column: 15
        }
      },
      '44': {
        start: {
          line: 77,
          column: 9
        },
        end: {
          line: 77,
          column: 33
        }
      },
      '45': {
        start: {
          line: 78,
          column: 9
        },
        end: {
          line: 78,
          column: 34
        }
      },
      '46': {
        start: {
          line: 79,
          column: 9
        },
        end: {
          line: 79,
          column: 15
        }
      },
      '47': {
        start: {
          line: 81,
          column: 9
        },
        end: {
          line: 81,
          column: 33
        }
      },
      '48': {
        start: {
          line: 82,
          column: 9
        },
        end: {
          line: 82,
          column: 34
        }
      },
      '49': {
        start: {
          line: 83,
          column: 9
        },
        end: {
          line: 83,
          column: 15
        }
      },
      '50': {
        start: {
          line: 86,
          column: 5
        },
        end: {
          line: 86,
          column: 32
        }
      },
      '51': {
        start: {
          line: 89,
          column: 3
        },
        end: {
          line: 94,
          column: 5
        }
      },
      '52': {
        start: {
          line: 90,
          column: 5
        },
        end: {
          line: 90,
          column: 30
        }
      },
      '53': {
        start: {
          line: 91,
          column: 5
        },
        end: {
          line: 93,
          column: 6
        }
      },
      '54': {
        start: {
          line: 92,
          column: 7
        },
        end: {
          line: 92,
          column: 31
        }
      },
      '55': {
        start: {
          line: 96,
          column: 3
        },
        end: {
          line: 133,
          column: 5
        }
      },
      '56': {
        start: {
          line: 97,
          column: 5
        },
        end: {
          line: 132,
          column: 8
        }
      },
      '57': {
        start: {
          line: 109,
          column: 7
        },
        end: {
          line: 111,
          column: 8
        }
      },
      '58': {
        start: {
          line: 110,
          column: 9
        },
        end: {
          line: 110,
          column: 16
        }
      },
      '59': {
        start: {
          line: 112,
          column: 7
        },
        end: {
          line: 112,
          column: 31
        }
      },
      '60': {
        start: {
          line: 113,
          column: 28
        },
        end: {
          line: 119,
          column: 8
        }
      },
      '61': {
        start: {
          line: 120,
          column: 7
        },
        end: {
          line: 131,
          column: 10
        }
      },
      '62': {
        start: {
          line: 121,
          column: 9
        },
        end: {
          line: 128,
          column: 10
        }
      },
      '63': {
        start: {
          line: 122,
          column: 11
        },
        end: {
          line: 125,
          column: 14
        }
      },
      '64': {
        start: {
          line: 126,
          column: 11
        },
        end: {
          line: 126,
          column: 36
        }
      },
      '65': {
        start: {
          line: 127,
          column: 11
        },
        end: {
          line: 127,
          column: 18
        }
      },
      '66': {
        start: {
          line: 129,
          column: 9
        },
        end: {
          line: 129,
          column: 28
        }
      },
      '67': {
        start: {
          line: 130,
          column: 9
        },
        end: {
          line: 130,
          column: 25
        }
      },
      '68': {
        start: {
          line: 137,
          column: 3
        },
        end: {
          line: 151,
          column: 5
        }
      },
      '69': {
        start: {
          line: 138,
          column: 26
        },
        end: {
          line: 138,
          column: 59
        }
      },
      '70': {
        start: {
          line: 139,
          column: 5
        },
        end: {
          line: 139,
          column: 31
        }
      },
      '71': {
        start: {
          line: 140,
          column: 18
        },
        end: {
          line: 140,
          column: 101
        }
      },
      '72': {
        start: {
          line: 141,
          column: 5
        },
        end: {
          line: 145,
          column: 6
        }
      },
      '73': {
        start: {
          line: 142,
          column: 7
        },
        end: {
          line: 142,
          column: 17
        }
      },
      '74': {
        start: {
          line: 143,
          column: 7
        },
        end: {
          line: 143,
          column: 32
        }
      },
      '75': {
        start: {
          line: 144,
          column: 7
        },
        end: {
          line: 144,
          column: 14
        }
      },
      '76': {
        start: {
          line: 146,
          column: 5
        },
        end: {
          line: 146,
          column: 60
        }
      },
      '77': {
        start: {
          line: 147,
          column: 5
        },
        end: {
          line: 150,
          column: 8
        }
      },
      '78': {
        start: {
          line: 148,
          column: 7
        },
        end: {
          line: 148,
          column: 27
        }
      },
      '79': {
        start: {
          line: 149,
          column: 7
        },
        end: {
          line: 149,
          column: 23
        }
      },
      '80': {
        start: {
          line: 152,
          column: 3
        },
        end: {
          line: 154,
          column: 5
        }
      },
      '81': {
        start: {
          line: 153,
          column: 5
        },
        end: {
          line: 153,
          column: 41
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 47
          },
          end: {
            line: 2,
            column: 48
          }
        },
        loc: {
          start: {
            line: 2,
            column: 159
          },
          end: {
            line: 134,
            column: 2
          }
        },
        line: 2
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 21,
            column: 19
          },
          end: {
            line: 21,
            column: 20
          }
        },
        loc: {
          start: {
            line: 21,
            column: 31
          },
          end: {
            line: 27,
            column: 4
          }
        },
        line: 21
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 23,
            column: 52
          },
          end: {
            line: 23,
            column: 53
          }
        },
        loc: {
          start: {
            line: 23,
            column: 60
          },
          end: {
            line: 26,
            column: 6
          }
        },
        line: 23
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 30,
            column: 19
          },
          end: {
            line: 30,
            column: 20
          }
        },
        loc: {
          start: {
            line: 30,
            column: 31
          },
          end: {
            line: 38,
            column: 4
          }
        },
        line: 30
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 40,
            column: 20
          },
          end: {
            line: 40,
            column: 21
          }
        },
        loc: {
          start: {
            line: 40,
            column: 36
          },
          end: {
            line: 52,
            column: 4
          }
        },
        line: 40
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 54,
            column: 22
          },
          end: {
            line: 54,
            column: 23
          }
        },
        loc: {
          start: {
            line: 54,
            column: 34
          },
          end: {
            line: 58,
            column: 4
          }
        },
        line: 54
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 60,
            column: 23
          },
          end: {
            line: 60,
            column: 24
          }
        },
        loc: {
          start: {
            line: 60,
            column: 39
          },
          end: {
            line: 87,
            column: 4
          }
        },
        line: 60
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 89,
            column: 29
          },
          end: {
            line: 89,
            column: 30
          }
        },
        loc: {
          start: {
            line: 89,
            column: 41
          },
          end: {
            line: 94,
            column: 4
          }
        },
        line: 89
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 96,
            column: 26
          },
          end: {
            line: 96,
            column: 27
          }
        },
        loc: {
          start: {
            line: 96,
            column: 42
          },
          end: {
            line: 133,
            column: 4
          }
        },
        line: 96
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 108,
            column: 8
          },
          end: {
            line: 108,
            column: 9
          }
        },
        loc: {
          start: {
            line: 108,
            column: 21
          },
          end: {
            line: 132,
            column: 6
          }
        },
        line: 108
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 120,
            column: 96
          },
          end: {
            line: 120,
            column: 97
          }
        },
        loc: {
          start: {
            line: 120,
            column: 104
          },
          end: {
            line: 131,
            column: 8
          }
        },
        line: 120
      },
      '11': {
        name: 'UnitsCtrl_edit',
        decl: {
          start: {
            line: 136,
            column: 10
          },
          end: {
            line: 136,
            column: 24
          }
        },
        loc: {
          start: {
            line: 136,
            column: 75
          },
          end: {
            line: 155,
            column: 2
          }
        },
        line: 136
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 137,
            column: 25
          },
          end: {
            line: 137,
            column: 26
          }
        },
        loc: {
          start: {
            line: 137,
            column: 37
          },
          end: {
            line: 151,
            column: 4
          }
        },
        line: 137
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 147,
            column: 98
          },
          end: {
            line: 147,
            column: 99
          }
        },
        loc: {
          start: {
            line: 147,
            column: 104
          },
          end: {
            line: 150,
            column: 6
          }
        },
        line: 147
      },
      '14': {
        name: '(anonymous_14)',
        decl: {
          start: {
            line: 152,
            column: 23
          },
          end: {
            line: 152,
            column: 24
          }
        },
        loc: {
          start: {
            line: 152,
            column: 35
          },
          end: {
            line: 154,
            column: 4
          }
        },
        line: 152
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 4,
            column: 3
          },
          end: {
            line: 6,
            column: 4
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 4,
            column: 3
          },
          end: {
            line: 6,
            column: 4
          }
        }, {
          start: {
            line: 4,
            column: 3
          },
          end: {
            line: 6,
            column: 4
          }
        }],
        line: 4
      },
      '1': {
        loc: {
          start: {
            line: 43,
            column: 44
          },
          end: {
            line: 43,
            column: 74
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 43,
            column: 44
          },
          end: {
            line: 43,
            column: 69
          }
        }, {
          start: {
            line: 43,
            column: 73
          },
          end: {
            line: 43,
            column: 74
          }
        }],
        line: 43
      },
      '2': {
        loc: {
          start: {
            line: 63,
            column: 5
          },
          end: {
            line: 85,
            column: 6
          }
        },
        type: 'switch',
        locations: [{
          start: {
            line: 64,
            column: 7
          },
          end: {
            line: 67,
            column: 15
          }
        }, {
          start: {
            line: 68,
            column: 7
          },
          end: {
            line: 71,
            column: 15
          }
        }, {
          start: {
            line: 72,
            column: 7
          },
          end: {
            line: 75,
            column: 15
          }
        }, {
          start: {
            line: 76,
            column: 7
          },
          end: {
            line: 79,
            column: 15
          }
        }, {
          start: {
            line: 80,
            column: 7
          },
          end: {
            line: 83,
            column: 15
          }
        }, {
          start: {
            line: 84,
            column: 7
          },
          end: {
            line: 84,
            column: 15
          }
        }],
        line: 63
      },
      '3': {
        loc: {
          start: {
            line: 91,
            column: 5
          },
          end: {
            line: 93,
            column: 6
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 91,
            column: 5
          },
          end: {
            line: 93,
            column: 6
          }
        }, {
          start: {
            line: 91,
            column: 5
          },
          end: {
            line: 93,
            column: 6
          }
        }],
        line: 91
      },
      '4': {
        loc: {
          start: {
            line: 91,
            column: 9
          },
          end: {
            line: 91,
            column: 57
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 91,
            column: 9
          },
          end: {
            line: 91,
            column: 31
          }
        }, {
          start: {
            line: 91,
            column: 35
          },
          end: {
            line: 91,
            column: 57
          }
        }],
        line: 91
      },
      '5': {
        loc: {
          start: {
            line: 109,
            column: 7
          },
          end: {
            line: 111,
            column: 8
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 109,
            column: 7
          },
          end: {
            line: 111,
            column: 8
          }
        }, {
          start: {
            line: 109,
            column: 7
          },
          end: {
            line: 111,
            column: 8
          }
        }],
        line: 109
      },
      '6': {
        loc: {
          start: {
            line: 121,
            column: 9
          },
          end: {
            line: 128,
            column: 10
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 121,
            column: 9
          },
          end: {
            line: 128,
            column: 10
          }
        }, {
          start: {
            line: 121,
            column: 9
          },
          end: {
            line: 128,
            column: 10
          }
        }],
        line: 121
      },
      '7': {
        loc: {
          start: {
            line: 141,
            column: 5
          },
          end: {
            line: 145,
            column: 6
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 141,
            column: 5
          },
          end: {
            line: 145,
            column: 6
          }
        }, {
          start: {
            line: 141,
            column: 5
          },
          end: {
            line: 145,
            column: 6
          }
        }],
        line: 141
      },
      '8': {
        loc: {
          start: {
            line: 141,
            column: 9
          },
          end: {
            line: 141,
            column: 43
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 141,
            column: 9
          },
          end: {
            line: 141,
            column: 13
          }
        }, {
          start: {
            line: 141,
            column: 17
          },
          end: {
            line: 141,
            column: 43
          }
        }],
        line: 141
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0, 0, 0, 0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_1k87b9rbsn.s[0]++;

angular.module('app').controller('UnitsCtrl', function ($scope, SweetAlert, $uibModal, $translate, $CRUDService, $otherHttpService, $location, $filter, $rootScope) {
  cov_1k87b9rbsn.f[0]++;
  cov_1k87b9rbsn.s[1]++;

  $rootScope.processPageRight('1_2');
  cov_1k87b9rbsn.s[2]++;
  if ($rootScope.global_access_page_denied) {
    cov_1k87b9rbsn.b[0][0]++;
    cov_1k87b9rbsn.s[3]++;

    return;
  } else {
    cov_1k87b9rbsn.b[0][1]++;
  }
  cov_1k87b9rbsn.s[4]++;
  $scope.add = false;
  cov_1k87b9rbsn.s[5]++;
  $scope.edit = false;
  cov_1k87b9rbsn.s[6]++;
  $scope.btnAction = false;
  cov_1k87b9rbsn.s[7]++;
  $scope.listUnits = [];
  cov_1k87b9rbsn.s[8]++;
  $scope.PATH = 'Unite';
  cov_1k87b9rbsn.s[9]++;
  $scope.TypeUnite = true;
  cov_1k87b9rbsn.s[10]++;
  $scope.idTypeUnit = '1';
  var project = (cov_1k87b9rbsn.s[11]++, $rootScope.getCurrentProject());
  cov_1k87b9rbsn.s[12]++;
  $scope.TypeUnit = [{ text: $translate.instant('FN_UNIT.CB_N'), id: 1 }, { text: '%', id: 2 }, { text: $translate.instant('FN_UNIT.CB_T'), id: 3 }];

  cov_1k87b9rbsn.s[13]++;
  $scope.getAll = function () {
    cov_1k87b9rbsn.f[1]++;
    cov_1k87b9rbsn.s[14]++;

    $scope.isloading = true;
    cov_1k87b9rbsn.s[15]++;
    $CRUDService.getAll($scope.PATH, { get: 'all' }, function (data) {
      cov_1k87b9rbsn.f[2]++;
      cov_1k87b9rbsn.s[16]++;

      $scope.listUnits = data;
      cov_1k87b9rbsn.s[17]++;
      $scope.isloading = false;
    });
  };
  cov_1k87b9rbsn.s[18]++;
  $scope.getAll();

  cov_1k87b9rbsn.s[19]++;
  $scope.addnew = function () {
    cov_1k87b9rbsn.f[3]++;
    cov_1k87b9rbsn.s[20]++;

    $scope.setEdit({
      CODE_UNITE: '',
      LIBELLE_UNITES: '',
      TYPE_UNITES: 1,
      FORMAT_UNITE: 0,
      id: 0
    });
  };

  cov_1k87b9rbsn.s[21]++;
  $scope.setEdit = function (item) {
    cov_1k87b9rbsn.f[4]++;

    var validateItem = (cov_1k87b9rbsn.s[22]++, angular.copy(item));
    cov_1k87b9rbsn.s[23]++;
    validateItem.TYPE_UNITES = $filter('filter')($scope.TypeUnit, { id: validateItem.TYPE_UNITES })[0];
    cov_1k87b9rbsn.s[24]++;
    validateItem.FORMAT_UNITE = parseFloat((cov_1k87b9rbsn.b[1][0]++, validateItem.FORMAT_UNITE) || (cov_1k87b9rbsn.b[1][1]++, 0));
    cov_1k87b9rbsn.s[25]++;
    $scope.validateItem = validateItem;
    cov_1k87b9rbsn.s[26]++;
    $uibModal.open({
      templateUrl: 'app/Units/edit.html',
      controller: UnitsCtrl_edit,
      scope: $scope,
      size: 'sm',
      windowClass: 'animated fadeInRight left-modal'
    });
  };

  cov_1k87b9rbsn.s[27]++;
  $scope.setCancel = function () {
    cov_1k87b9rbsn.f[5]++;
    cov_1k87b9rbsn.s[28]++;

    $scope.add = false;
    cov_1k87b9rbsn.s[29]++;
    $scope.edit = false;
    cov_1k87b9rbsn.s[30]++;
    $scope.btnAction = false;
  };

  cov_1k87b9rbsn.s[31]++;
  $scope.selectUnit = function (Unit) {
    cov_1k87b9rbsn.f[6]++;
    cov_1k87b9rbsn.s[32]++;

    $scope.btnAction = true;
    cov_1k87b9rbsn.s[33]++;
    $scope.idTypeUnit = '1';
    cov_1k87b9rbsn.s[34]++;
    switch (Unit.TYPE_UNITES) {
      case $translate.instant('FN_UNIT.CB_N'):
        cov_1k87b9rbsn.b[2][0]++;
        cov_1k87b9rbsn.s[35]++;

        $scope.idTypeUnit = '1';
        cov_1k87b9rbsn.s[36]++;
        $scope.TypeUnite = true; // "Numérique";
        cov_1k87b9rbsn.s[37]++;
        break;
      case '%':
        cov_1k87b9rbsn.b[2][1]++;
        cov_1k87b9rbsn.s[38]++;

        $scope.idTypeUnit = '2';
        cov_1k87b9rbsn.s[39]++;
        $scope.TypeUnite = true;
        cov_1k87b9rbsn.s[40]++;
        break;
      case $translate.instant('FN_UNIT.CB_T'):
        cov_1k87b9rbsn.b[2][2]++;
        cov_1k87b9rbsn.s[41]++;

        $scope.idTypeUnit = '3';
        cov_1k87b9rbsn.s[42]++;
        $scope.TypeUnite = false; // "Texte";
        cov_1k87b9rbsn.s[43]++;
        break;
      case $translate.instant('FN_UNIT.CB_B'):
        cov_1k87b9rbsn.b[2][3]++;
        cov_1k87b9rbsn.s[44]++;

        $scope.idTypeUnit = '4';
        cov_1k87b9rbsn.s[45]++;
        $scope.TypeUnite = false; // "Booléen";
        cov_1k87b9rbsn.s[46]++;
        break;
      case 'Date':
        cov_1k87b9rbsn.b[2][4]++;
        cov_1k87b9rbsn.s[47]++;

        $scope.idTypeUnit = '5';
        cov_1k87b9rbsn.s[48]++;
        $scope.TypeUnite = false;
        cov_1k87b9rbsn.s[49]++;
        break;
      default:
        cov_1k87b9rbsn.b[2][5]++;

    }
    cov_1k87b9rbsn.s[50]++;
    $scope.validateItem = Unit;
  };

  cov_1k87b9rbsn.s[51]++;
  $scope.changedValueType = function () {
    cov_1k87b9rbsn.f[7]++;
    cov_1k87b9rbsn.s[52]++;

    $scope.TypeUnite = false;
    cov_1k87b9rbsn.s[53]++;
    if ((cov_1k87b9rbsn.b[4][0]++, $scope.idTypeUnit == 1) || (cov_1k87b9rbsn.b[4][1]++, $scope.idTypeUnit == 2)) {
      cov_1k87b9rbsn.b[3][0]++;
      cov_1k87b9rbsn.s[54]++;

      $scope.TypeUnite = true;
    } else {
      cov_1k87b9rbsn.b[3][1]++;
    }
  };

  cov_1k87b9rbsn.s[55]++;
  $scope.setDeleteData = function (item) {
    cov_1k87b9rbsn.f[8]++;
    cov_1k87b9rbsn.s[56]++;

    SweetAlert.swal({
      title: $translate.instant('COMMON.CONFIRM'),
      text: $translate.instant('FN_UNIT.CONFIRM_DELETE'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#c8c8c8',
      cancelButtonColor: '#DD6B55',
      confirmButtonText: $translate.instant('COMMON.YES'),
      cancelButtonText: $translate.instant('COMMON.NO'),
      closeOnConfirm: true,
      closeOnCancel: true
    }, function (isconfirm) {
      cov_1k87b9rbsn.f[9]++;
      cov_1k87b9rbsn.s[57]++;

      if (!isconfirm) {
        cov_1k87b9rbsn.b[5][0]++;
        cov_1k87b9rbsn.s[58]++;

        return;
      } else {
        cov_1k87b9rbsn.b[5][1]++;
      }
      cov_1k87b9rbsn.s[59]++;
      $scope.isloading = true;
      var validateItem = (cov_1k87b9rbsn.s[60]++, {
        CODE_UNITE: item.CODE_UNITE,
        LIBELLE_UNITES: item.LIBELLE_UNITES,
        TYPE_UNITES: $scope.idTypeUnit,
        FORMAT_UNITE: item.FORMAT_UNITE,
        id: item.id
      });
      cov_1k87b9rbsn.s[61]++;
      $CRUDService.delet($scope.PATH, { action: 'supp', valeur: $filter('json')(validateItem) }, function (data) {
        cov_1k87b9rbsn.f[10]++;
        cov_1k87b9rbsn.s[62]++;

        if (data < 0) {
          cov_1k87b9rbsn.b[6][0]++;
          cov_1k87b9rbsn.s[63]++;

          SweetAlert.swal({
            title: $translate.instant('COMMON.ERROR_DELETE'),
            text: $translate.instant('COMMON.TITLE_ERROR_DELETE')
          });
          cov_1k87b9rbsn.s[64]++;
          $scope.isloading = false;
          cov_1k87b9rbsn.s[65]++;
          return;
        } else {
          cov_1k87b9rbsn.b[6][1]++;
        }
        cov_1k87b9rbsn.s[66]++;
        $scope.setCancel();
        cov_1k87b9rbsn.s[67]++;
        $scope.getAll();
      });
    });
  };
});

function UnitsCtrl_edit($scope, $uibModalInstance, $filter, $CRUDService) {
  cov_1k87b9rbsn.f[11]++;
  cov_1k87b9rbsn.s[68]++;

  $scope.setValidData = function () {
    cov_1k87b9rbsn.f[12]++;

    var validateItem = (cov_1k87b9rbsn.s[69]++, angular.copy($scope.validateItem));
    cov_1k87b9rbsn.s[70]++;
    $scope.error_code = false;
    var item = (cov_1k87b9rbsn.s[71]++, $filter('filter')($scope.listUnits, { CODE_UNITE: validateItem.CODE_UNITE }, true)[0]);
    cov_1k87b9rbsn.s[72]++;
    if ((cov_1k87b9rbsn.b[8][0]++, item) && (cov_1k87b9rbsn.b[8][1]++, item.id != validateItem.id)) {
      cov_1k87b9rbsn.b[7][0]++;
      cov_1k87b9rbsn.s[73]++;

      error = 1;
      cov_1k87b9rbsn.s[74]++;
      $scope.error_code = true;
      cov_1k87b9rbsn.s[75]++;
      return;
    } else {
      cov_1k87b9rbsn.b[7][1]++;
    }
    cov_1k87b9rbsn.s[76]++;
    validateItem.TYPE_UNITES = validateItem.TYPE_UNITES.id;
    cov_1k87b9rbsn.s[77]++;
    $CRUDService.save($scope.PATH, { action: 'MiseAJour', valeur: $filter('json')(validateItem) }, function () {
      cov_1k87b9rbsn.f[13]++;
      cov_1k87b9rbsn.s[78]++;

      $scope.closeModal();
      cov_1k87b9rbsn.s[79]++;
      $scope.getAll();
    });
  };
  cov_1k87b9rbsn.s[80]++;
  $scope.closeModal = function () {
    cov_1k87b9rbsn.f[14]++;
    cov_1k87b9rbsn.s[81]++;

    $uibModalInstance.dismiss('cancel');
  };
}